<template>
  <div id="page-content-wrapper" class="login">
    <div class="container-fluid">
      <b-form @submit="onSubmit">
        <div class="contents">
          <div class="d-flex justify-content-center mt-2 mb-4">
            <img src="/img/logo_black.png" alt="X-GOLF" />
          </div>
          <h3>{{ $t("page.login.shop_login") }}</h3>
          <!-- label class="mb-2 d-block -text-dgray">ID</label -->
          <input
            type="text"
            class="form-control form-control-lg mb-3"
            :placeholder="$t('title.common.id')"
            aria-label=""
            v-model="form.id"
          />
          <!-- label class="mb-2 d-block -text-dgray">Password</label -->
          <input
            type="password"
            class="form-control form-control-lg mb-3"
            :placeholder="$t('title.common.password')"
            aria-label=""
            v-model="form.password"
          />
          <div class="row mb-3">
            <div class="col-lg-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexCheck"
                  v-model="form.rememberYn"
                  value="Y"
                />
                <label class="form-check-label" for="flexCheck"
                  >{{ $t("text.login.remember_id") }}</label
                >
              </div>
            </div>
            <div class="col-lg-6 align-right">
              <!-- a class="d-inline-block font-14">Forgot your password?</a -->
            </div>
          </div>
          <input
            class="btn btn-primary btn-lg w-100"
            type="submit"
            :value="$t('button.login.login')"
          />
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import ax from "@/api/auth";
import _ from "lodash";
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "@/components/common/validations/inputbox";

export default {
  name: "Login",
  data() {
    return {
      form: {
        id: localStorage.getItem("remember_id") || "",
        password: "",
        rememberYn: localStorage.getItem("remember_yn") || "",
      },
    };
  },
  created() {
    this.form = _.cloneDeep(this.form);
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      ax.getToken(this.form, (flag, data) => {
        if (flag) {
          this.$router.push("/");
        } else {
          alert(data.message);
          // this.$notify({
          //   group: "alert",
          //   type: "warn",
          //   title: "Notice",
          //   text: data.message,
          // });
        }
      });
    },
    resetForm() {
      this.form = _.cloneDeep(this.form);
    },
  },
};
</script>
